// ===== nav menu below 600px ====== //

function navUnder600() {
	var win = $(this); //this = window
	if (win.width() <= 600) {
		$("html.hex__hav_opened .nav-menu-main-wrap ").css("width", "100vw");
	} else {
		$("html.hex__hav_opened .nav-menu-main-wrap ").css("width", "350px");
	}
}

function mobileRes(width, path) {
	$(path).css("width", width);
}

// ===== resize function ==== //

$(window).on("resize", function () {
	var win = $(this); //this = window

	if (win.width() >= 1100) {
		$("html").removeClass("hex__hav_opened");
		$("html").removeClass("child_nav_opened");
		$(".nav-menu-main-wrap").removeClass("nav-menu-main-wrap--transtion");
		$(".search-main-wrap").removeClass("search-main-wrap--show");
		$("html .nav-menu-main-wrap ").css("width", "100%");
	}

	if (win.width() < 1101) {
		$("html .nav-menu-main-wrap ").css("width", "0px");
	}

	if ($(window).width() <= 992) {
		$("html .nav-menu-main-wrap ").css("width", "0");
	}
	navUnder600();
});

// ===== header animation  ====== //

$(document).ready(function () {
	var win = $(this); //this = window

	$(".logo-main-wrap__mobile").click(function (e) {
		$("html .nav-menu-main-wrap ").css("width", "350px");
		$("html").removeClass("search-wrap");
		$("html").toggleClass("hex__hav_opened");
		$(".nav-menu-main-wrap").addClass("nav-menu-main-wrap--transtion");
		$("html").removeClass("child_nav_opened");
		var outhgt = $(".notification-banner-main-wrap").height();
		notificationNavHeight(outhgt);
		$(".nav-sub-menu-wrap__dropdown").removeClass("hex__child_nav_opened");
		if ($("html").hasClass("hex__hav_opened")) {
			$(".nav-main-inner-wrap").css("overflow", "unset");
			$(".dropdown-menu__title-trigger.active").click();
		} else {
			setTimeout(function () {
				$("html .nav-menu-main-wrap").css("width", "0");
				// $('.nav-main-inner-wrap').css('overflow', 'hidden');
			}, 100);
			$(".nav-main-inner-wrap").css("overflow", "unset");
		}
		navUnder600();
	});

	$(".nav-sub-menu-wrap__link").click(function (e) {
		$(this)
			.next(".nav-sub-menu-wrap__dropdown")
			.addClass("hex__child_nav_opened");
		$("html").addClass("child_nav_opened");
		$(".nav-sub-menu-wrap__login-wrap").css({ "margin-bottom": 0 + "px" });
	});
	$(".nav-sub-menu-wrap__dropdown-menu-backward").click(function () {
		$(this)
			.parents(".nav-sub-menu-wrap__dropdown")
			.removeClass("hex__child_nav_opened");
		$(".dropdown-menu__title-trigger.active").click();
		$("html").toggleClass("child_nav_opened");
		var outhgt = $(".notification-banner-main-wrap").height();
		notificationNavHeight(outhgt);
	});
	$(".dropdown-menu__title-trigger").click(function (e) {
		var $this = $(this);
		$this.toggleClass("active");
		$this
			.parents(".nav-sub-menu-wrap__scroller")
			.find(".dropdown-menu__title-trigger")
			.removeClass("active");
		$this
			.parents(".nav-sub-menu-wrap__scroller")
			.find(".dropdown-menu__sub-wrap")
			.slideUp(250);
		var selected = $this.next(".dropdown-menu__sub-wrap");
		if (selected.is(":hidden")) {
			$this.next(".dropdown-menu__sub-wrap").slideDown(250);
			$this.toggleClass("active");
		}
	});
});

setTimeout(function () {
	var outhgt = $(".notification-banner-main-wrap").height();
	var lastScrollTop = 0;
	$(document)
		.on("scroll load", function () {
			var st = $(this).scrollTop();
			// console.log(st);
			if (st > lastScrollTop) {
				$("html").addClass("scroll-down");
				$("html").removeClass("scroll-up");
			} else {
				$("html").removeClass("scroll-down");
				$("html").addClass("scroll-up");
				// $(".nav-main-inner-wrap").delay(500).css({
				// 	animation: "none",
				// });
			}
			lastScrollTop = st;
			var noti_length = $(".notification-banner-main-wrap").height();
			// console.log('noti_length',noti_length);
			// console.log('st',st);
			if (noti_length == undefined) {
				// console.log('undefined condition');
				if (st <= 0) {
					$("html").addClass("scroll-hide");
					$("html").removeClass("scroll-up");
				} else {
					$("html").removeClass("scroll-hide");
				}
			} else {
				// console.log('value condition');
				if (st <= noti_length) {
					$("html").addClass("scroll-hide");
				} else {
					$("html").removeClass("scroll-hide");
				}
			}
		})
		.scroll();
}, 1000);

// ===== header animation  ====== //

// === nav height wrt banner notification height ==== //

function notificationNavHeight(outhgt) {
	// alert($(window).width());

	if ($(window).width() <= 1100 && $("html").hasClass("scroll-hide")) {
		// var outhgt = $('.notification-banner-main-wrap').height();
		// var outhgt20 = outhgt - 20;
		var buffer = 100;
		var logbuffer = 80;
		$(".scroll-hide .nav-sub-menu-wrap__dropdown-menu:last-child").css({
			"margin-bottom": outhgt + buffer + "px",
		});
		$(".scroll-hide .nav-sub-menu-wrap__login-wrap").css({
			"margin-bottom": outhgt + logbuffer + "px",
		});
		// $('.nav-main-inner-wrap.nav-main-inner-wrap--trail-days .nav-sub-menu-bottom-wrap .nav-menu-main-wrap').css({'height':'calc(100vh - ' + outhgt20 +'px'});
	} else {
		$(".nav-sub-menu-wrap__dropdown-menu:last-child").css({
			"margin-bottom": 0 + "px",
		});
		$(".nav-sub-menu-wrap__login-wrap").css({ "margin-bottom": 0 + "px" });
		// $('.nav-main-inner-wrap.nav-main-inner-wrap--trail-days .nav-sub-menu-bottom-wrap .nav-menu-main-wrap').css({'height':0+'px'});
	}
}

// ======= on load function ======= //

$(window).on("load resize", function () {
	navUnder600();

	if ($(window).width() <= 1199) {
		var outhgt = $(".notification-banner-main-wrap").height();
		notificationNavHeight(outhgt);
	}
});

// ======= on scroll function ======= //

$(window).on("scroll", function () {
	if ($(window).width() <= 1199) {
		var outhgt = $(".notification-banner-main-wrap").height();
		notificationNavHeight(outhgt);
	}
});

// $(window).on("load", function () {

// 	if ($('html').hasClass('first-load')) {

// 		$('.notification-banner-main-wrap').css({
// 			"display": "block"
// 		});
// 	} else {

// 		$('.notification-banner-main-wrap').delay(500).css({
// 			"display": "block",
// 			"animation": "0.4s ease-out slideInFromTop"
// 		});
// 		$('.nav-main-wrap').css({
// 			"animation": "0.4s ease-out slideInFromTop"
// 		});
// 		$(".webpage-wrapper").delay(500).css({
// 			"animation": "0.4s ease-out slideInFromTopY",
// 			"top": "-21px",
// 			"transition": "all 0.4s ease-out"
// 		});
// 	}

// });

// ===== notification banner close ===== //

$(document).on(
	"click",
	".nav-main-wrap .notification-banner-main-wrap svg.notification-banner-close",
	function () {
		$(this).parent().fadeOut(500);
		setTimeout(() => {
			notificationbannerClose();
		}, 500);
	}
);

function notificationbannerClose() {
	$("body").addClass("bannerClose");
	console.log("Inside");
	$(".notification-banner-main-wrap").remove();
	var outhgt = 0;
	notificationNavHeight(outhgt);
}

// Detect OS for styling (css)

window.onload = function (event) {
	if (navigator.appVersion.indexOf("Win") != -1) {
		jQuery("body").addClass("hex__windows");
	}
};

//   search button

$(document).on(
	"click",
	".search-main-wrap form .search__custom-btn",
	function () {
		$(this).parent("form").find("input").val("");
		$("html").toggleClass("search-wrap");
		$(this).parents(".search-main-wrap").removeClass("search-main-wrap--show");
		$(".result-list-loader.result-list-wrap").css({ display: "block" });
	}
);

$(document).on(
	"click",
	".search-main-wrap form .search__custom-input input",
	function () {
		$(this).parents(".search-main-wrap").addClass("search-main-wrap--show");
		setTimeout(function () {
			$(".result-list-loader.result-list-wrap").css({ display: "none" });
		}, 400);

		// ==== aos intialisation === //
		AOS.init({
			once: false,
		});
	}
);
